import React from 'react'

const EmptyState = (props) => (
    <div>
        <h3>{props.title}</h3>
        <span>{props.message}</span>
    </div>
)

export default EmptyState


// WEBPACK FOOTER //
// ./src/components/EmptyState.js